module.exports = __webpack_public_path__ + "img/rocket.bf4bbc4f.png";